import { HttpClient, HttpContext } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ERROR_INTERCEPTOR_BYPASS } from '@helios/utils'
import { Observable } from 'rxjs'
import { map, mergeAll, toArray } from 'rxjs/operators'
import {
  Command,
  Exception,
  Job,
  JobCancelResponse,
  JobRequest,
  JobResubmitResponse,
  Status,
} from '../model/job.model'
import { JobsService } from './jobs.service'

export const JOBS_URL = `helios-jobs`
export const COMMANDS_URL = `${JOBS_URL}/{jobId}/commands`
export const COMMAND_LOGS_URL = `${JOBS_URL}/{jobId}/commandLogs`
export const EXCEPTION_URL = `${JOBS_URL}/{jobId}/exception`
export const STATUS_HISTORY_URL = `${JOBS_URL}/{jobId}/statusHistory`
export const CANCEL_URL = `${JOBS_URL}/cancel`
export const RESUBMIT_URL = `${JOBS_URL}/resubmit`

@Injectable({
  providedIn: 'root',
})
export class HttpJobsService extends JobsService {
  constructor(private readonly http: HttpClient) {
    super()
  }

  getJobs(request: JobRequest): Observable<Job[]> {
    return this.http.post<Job[]>(JOBS_URL, request, {
      context: new HttpContext().set(ERROR_INTERCEPTOR_BYPASS, [403]),
    })
  }

  getCommands(jobId: number): Observable<Command[]> {
    return this.http
      .get<Command[]>(COMMANDS_URL.replace('{jobId}', jobId.toString()))
      .pipe(
        mergeAll(),
        map(command => {
          if (command.timestamp == null) {
            return command
          }

          return {
            ...command,
            timestamp: command.timestamp.split('.')[0] + 'Z',
          }
        }),
        toArray(),
      )
  }

  getCommandLogs(jobId: number): Observable<Command[]> {
    return this.http
      .get<Command[]>(COMMAND_LOGS_URL.replace('{jobId}', jobId.toString()))
      .pipe(
        mergeAll(),
        map(command => {
          if (command.timestamp == null) {
            return command
          }

          return {
            ...command,
            timestamp: command.timestamp.split('.')[0] + 'Z',
          }
        }),
        toArray(),
      )
  }

  getException(jobId: number): Observable<Exception> {
    return this.http.get<Exception>(
      EXCEPTION_URL.replace('{jobId}', jobId.toString()),
    )
  }

  getStatus(jobId: number): Observable<Status[]> {
    return this.http
      .get<Status[]>(STATUS_HISTORY_URL.replace('{jobId}', jobId.toString()))
      .pipe(
        mergeAll(),
        map(status => ({
          ...status,
          ts: status.ts.split('.')[0] + 'Z',
        })),
        toArray(),
      )
  }

  cancelJobs(jobIds: number[]): Observable<JobCancelResponse> {
    return this.http.delete<JobCancelResponse>(CANCEL_URL, {
      body: jobIds,
    })
  }

  resubmitJobs(jobIds: number[]): Observable<JobResubmitResponse> {
    return this.http.put<JobResubmitResponse>(RESUBMIT_URL, jobIds)
  }
}
